module.exports = __webpack_public_path__ + "img/date2.aff3606b.svg";